// services/roleService.ts
import { Role } from "../types";

const STORAGE_KEY = "ats_roles_data";

// Default roles to populate if storage is empty
const DEFAULT_ROLES: Role[] = [
  {
    id: "1",
    title: "Frontend Engineer",
    department: "Engineering",
    location: "Remote",
  },
  {
    id: "2",
    title: "Backend Engineer",
    department: "Engineering",
    location: "New York",
  },
  {
    id: "3",
    title: "Product Manager",
    department: "Product",
    location: "London",
  },
  { id: "4", title: "Designer", department: "Design", location: "Remote" },
];

export const RoleService = {
  getAll: (): Role[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) {
      // Initialize with defaults if empty
      localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_ROLES));
      return DEFAULT_ROLES;
    }
    return JSON.parse(data);
  },

  add: (role: Omit<Role, "id">): Role => {
    const current = RoleService.getAll();
    const newRole: Role = {
      ...role,
      id: crypto.randomUUID(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...current, newRole]));
    return newRole;
  },

  delete: (id: string): void => {
    const current = RoleService.getAll();
    const filtered = current.filter((r) => r.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  },

  saveAll: (roles: Role[]): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(roles));
  },
};
